import React from 'react'
import styled from 'styled-components'
import Grid from '@blocks/Grid'
import Button from '@blocks/Button'

export default function ArchiveEmpty({ empty }: Pick<ArchiveOptions, "empty">) {
    if (!empty) return null
    
    return (
        <Empty>
            <Grid>
                <div>
                    <h2 className="h3">{empty.heading || "Sorry, the list is empty."}</h2>
                    <p>{empty.description || "Try to visit the page later."}</p>
                </div>
                {empty.button && <Button width="fixed" to={empty.button.to}>{empty.button.value}</Button>}
            </Grid>
        </Empty>
    )
}

// STYLES
const Empty = styled.div`
    .h3 {
        max-width: 500px;
    }

    p {
        max-width: 400px;
    }
`